import React from "react";

export default function Test(){
    return (
        <div>
            안녕하시오
        </div>
    )
}